/*  
	Proprietary Click/Scroll pagination Javascript for Blue Owl collection pages
	Adding event listeners, hide pagination box on click, history.pushstate.
    To reset original shopify pagination remove #appendMore and #appendPrev in collection page and chage pagination.style.display
    ***** Collection product lists hides 'archive' tagged products via 'if else statements' in the product-list div for loop (reference collection.liquid)
*/

var path = window.location.pathname;
var page = path.split("/").pop();
var containerElement;
if(page === "new-arrivals"){
  containerElement = '#productList';
} else if(page === "the-mill"){
  containerElement = '#millcontent';
} else {
  containerElement = '#productList';
}

//On document content load add next pagination function to appendMore div
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: containerElement, //container id for products
    pagination:'#appendMore', //next pagination div box
    method:'click'
  }); 
}); 

document.addEventListener("DOMContentLoaded", function() {
  var endlessScrollPrev = new Ajaxinate({
    container: containerElement, //container id for products
    pagination:'#appendPrev', //previous pagination div box
    method:'click'	
  }); 
}); 

//Adds scroll to top function to top div
document.getElementById('scrollTop').addEventListener('click', function (event) {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});

//hides buttons on click
function hideOnClick(selector){
  if(selector === 1){
    //checks for next pagination box id
    document.querySelector("#appendMore > a").style.display= "none";    
  } else if(selector === 2){
    //checks for previous pagination box id
    document.querySelector("#appendPrev > a").style.display= "none";
  } else {
    //null
  }
} 

//returns user to previous entry point without losing their scrolled page
function processAjaxData(selector){
  var subject, //Div id and html reference
      pageHref, //subjects html reference
      tempSplit, //split html reference to concatenate
      newUrl; //new url derived from tempsplit  
  if(selector === 1){
    //Case 1 for next pagination, sets next pagination url
    subject = document.querySelector("#appendMore > a");
    pageHref = subject.href;
    tempSplit = pageHref.split('/');
    newUrl = '/' + tempSplit[3] + '/' + tempSplit[4];
  } else if (selector === 2){
    //Case 2 for previous pagination, sets previous pagination url
    subject = document.querySelector("#appendPrev > a");
    pageHref = subject.href;
    tempSplit = pageHref.split('/');
    newUrl = '/' + tempSplit[3] + '/' + tempSplit[4];
  } else {
    //Case 3 sets url as null
    newUrl = '';
  }
  //Parameters (Object, Title, href)
  window.history.pushState(null,'', newUrl);
}	

/*
    //Timer for functions to optimize website speed
    function TimeIt() {
      var self = this;

      function howLong(iterations, testFunction) {
          var results = [];
          var total = 0;
          for (var i = 0; i < iterations; i++) {
              var start = performance.now();
              testFunction();
              var end = performance.now();
              var duration = end - start;
              results.push(duration);
              total += duration;
          }
          var result = {
                  results : results,
                  total : total,
                  avg : total / results.length
          }
          return result;
      }
      self.howLong = howLong;
 	}
    */